import { InternalServerErrorException } from '../../../common/exceptions/exceptions';
import { LogManager } from '../../../common/port/log/log.manager.port';
import { GetChallengeInsightProgressDigitalWorkingHoursSummaryApplicationService } from '../../../core/application/services/challenge-insights/get-challenge-insight-progress-digital-working-hours-summary.application-service';
import { ChallengeInsightProgressDigitalWorkingHoursSummaryAggregateRoot } from '../../../core/domain/aggregates/challenge-insights/challenge-insight-progress-digital-working-hours.aggregate-root';
import { GetChallengeInsightProgressSummaryRequestDto } from '../../dtos/challenge-insights/get-challenge-insight-progress-summary.request.dto';

export class GetChallengeInsightProgressDigitalWorkingHoursSummaryQuery {
  constructor(
    protected readonly logManager: LogManager,
    protected readonly service: GetChallengeInsightProgressDigitalWorkingHoursSummaryApplicationService
  ) {}
  async execute(
    props: GetChallengeInsightProgressSummaryRequestDto
  ): Promise<ChallengeInsightProgressDigitalWorkingHoursSummaryAggregateRoot> {
    try {
      return await this.service.execute(props);
    } catch (error) {
      throw new InternalServerErrorException(error);
    }
  }
}
